import dynamic from 'next/dynamic'
import React, { useState } from 'react'

import DeliveryTitle from '@/screens/Delivery/page/ui/DeliveryTitle/DeliveryTitle'

import { OpenRegionNavButton } from '@/widgets/RegionSelector/ui/OpenRegionNavButton/OpenRegionNavButton'

import { useRegion } from '@/entities/regions'

import { SPB_CITY_CODE } from '@/shared/lib/utils/constants/const'
import { USER_VIEW_TYPE_OPTIONS, UserViewType } from '@/shared/types/user-types'
import { FaqSection } from '@/shared/ui/FaqSection'
import { HorizontalSection } from '@/shared/ui/HorizontalSection'
import { Radio } from '@/shared/ui/radio'

import { deliveryPayGrid, deliveryPayGridYur, faqItems } from './data'
import { DeliveryInfoBlock } from './ui/DeliveryInfoBlock/DeliveryInfoBlock'
import { DeliveryNotes } from './ui/DeliveryNotes/DeliveryNotes'
import { DeliveryPayGrid } from './ui/DeliveryPayGrid/DeliveryPayGrid'

import cl from './index.module.scss'

const DeliveryZonesMap = dynamic(
	() => import('@/widgets/DeliveryZonesMap/ui/DeliveryZonesMap').then(mod => ({ default: mod.DeliveryZonesMap })),
	{
		ssr: false
	}
)

type DeliveryProps = {
	isModal?: boolean
}

export const Delivery = ({ isModal }: DeliveryProps) => {
	const { currentRegion } = useRegion()
	const [viewType, setViewType] = useState<UserViewType>(UserViewType.Fiz)
	const isSpbRegion = currentRegion.REGION_CODE === SPB_CITY_CODE

	return (
		<>
			<div className={cl.titleWrapper}>
				<DeliveryTitle
					title={'Доставка и оплата'}
					city={<OpenRegionNavButton className={cl.link}>{currentRegion.REGION_NAME}</OpenRegionNavButton>}
				/>
			</div>
			<Radio.Group value={viewType} onChange={e => setViewType(e.target.value as UserViewType)} buttonStyle="solid">
				{USER_VIEW_TYPE_OPTIONS.map(option => (
					<Radio.Button key={option.value} value={option.value} className={cl.radioButton}>
						{option.label}
					</Radio.Button>
				))}
			</Radio.Group>

			{viewType === UserViewType.Fiz && (
				<>
					<DeliveryInfoBlock region={currentRegion} isModal={isModal} />
					{isSpbRegion && <DeliveryZonesMap />}
					{!isModal && (
						<>
							<section className={cl.deliveryPay}>
								<h2 className={cl.deliveryPay__title}>Оплата</h2>
								<DeliveryPayGrid items={deliveryPayGrid} />
							</section>
							<HorizontalSection title="Частые вопросы" borderNone>
								<FaqSection items={faqItems} />
							</HorizontalSection>
							<DeliveryNotes />
						</>
					)}
				</>
			)}

			{viewType === UserViewType.Yur && (
				<>
					<DeliveryInfoBlock region={currentRegion} yurInfo={viewType === UserViewType.Yur} />
					{!isModal && (
						<>
							{' '}
							<section className={cl.deliveryPay}>
								<h2 className={cl.deliveryPay__title}>Оплата</h2>
								<DeliveryPayGrid items={viewType === UserViewType.Yur ? deliveryPayGridYur : deliveryPayGrid} />
							</section>
							<HorizontalSection title="Частые вопросы" borderNone>
								<FaqSection items={faqItems} />
							</HorizontalSection>
							<DeliveryNotes />
						</>
					)}
				</>
			)}
		</>
	)
}
